/* eslint-disable no-unused-vars */
// import helper from "./helper";
// import control from '../mixins/control'
// import keys from './keys';
let uitl = {};
let helper = null;
Object.defineProperty(uitl, "helper", {
  get() {
    if (!helper) {
      helper = require("./helper").default;
    }
    return helper;
  },
  enumerable: true,
  configurable: true
});

let pascalCaseRE = /^[A-Z][^\-]*$/g;

let __ctrls__ = {};
let __designOptionsCache__ = {};
let __designOptions__ = {};
let __designOptionsValue__ = {};
let __ctrlsValue__ = {};
let __options__ = {};
// let __temp__ = {};
let hasSymbol = typeof Symbol !== "undefined" && uitl.helper.isNative(Symbol) && typeof Reflect !== "undefined" && uitl.helper.isNative(Reflect.ownKeys);
let componentNameRE = /^(Dsf)(Mobile)?(\w+)/g;
let onlineComponents = {};

const asyncComponentReadError = "是一个尚未加载的异步组件无法直接获取组件选项配置信息";
const lazyComponentReadError = "可能是一个配置错误的懒加载组件";

window.__totalTiemSpan__ = 0;

//注册组件
function component(options) {
  options.isDsfComponent = true;
  checkComponentName(options.name);
  // console.time("注册组件"+options.name)
  // dsf.log(options.name)
  if (!options.ctrlCaption && options.mixins) {
    let hasCtrlCaption = false;
    options.mixins.forEach((mix) => {
      if (mix.ctrlCaption) {
        hasCtrlCaption = true;
      }
    });
    if (!hasCtrlCaption) {
      throw options.name + "组件缺少ctrlCaption属性";
    }
  }
  if (dsf.isUnDef(options.props)) {
    options.props = {};
  }
  let dsfCode = getCtrlCodeByName(options.name);
  options.props["ctrlType"] = {
    type: String,
    default: dsfCode
  };
  let ctrlType = dsfCode;
  options.ctrlType = ctrlType;
  options.ctrlName = options.name;
  // __designOptionsCache__[ctrlType] = options.desgin;
  // delete options.design;
  // dsf.global.$components[options.name] = options;
  // 增加强制覆盖 isForceCover
  //__options__[ctrlType]为一个方法就表示一个异步组件，当组件正式加载时覆盖已注册的异步方法
  if (!__options__[ctrlType] || dsf.isFunction(__options__[ctrlType]) || options.isForceCover) {
    __options__[ctrlType] = options;
    if (dsf.initedComponent == "inited") {
      //如果平台已经加载完毕,后续注册的组件(可能是异步组件)自动注册
      initComponents(ctrlType);
    }
    return options;
  } else {
    return __options__[ctrlType];
  }
}
//初始化组件
function initComponents(key) {

  let allOptions = __options__;
  if (key) {
    allOptions = {
      [key]: __options__[key]
    };
  }
  for (let k in allOptions) {
    let ctrlType = k.toLowerCase();
    // let ctrlType = options.ctrlType.toLowerCase();
    let options = allOptions[k];
    pascalCaseRE.lastIndex = 0;
    //异步组件或者懒加载组件
    if (dsf.isFunction(options)) {
      continue;
    }
    if (!options.props) {
      options.props = {};
    }
    if (!dsf.hasOwn(options.props, "ctrlName")) {
      options.props["ctrlName"] = {
        type: String,
        default: options.name
      };
    }
    if (!dsf.hasOwn(options.props, "ctrlType")) {
      componentNameRE.lastIndex = 0;
      let code = componentNameRE.exec(options.name);
      let arr = [];
      if (code && code.length > 0) {
        for (let i = 1; i < code.length; i++) {
          if (code[i]) {
            arr.push(code[i].toLowerCase());
          }
        }
      }
      let dsfCode = arr.join(".");
      options.props["ctrlType"] = {
        type: String,
        default: dsfCode
      };
      options.ctrlType = dsfCode;
    }

    // 优化初始化时间，将组件的数据处理延迟到使用时计算
    let design = options.design;
    delete options.desgin;
    Object.defineProperty(__ctrls__, ctrlType, {
      get() {
        if (__ctrlsValue__[ctrlType]) {
          return __ctrlsValue__[ctrlType];
        } else {
          let mixins = $getMinixsAndExtends(options, true, ["props", "design"]);
          let ctrlAttrs = $minixAttributes(options, mixins["props"]);
          __ctrlsValue__[ctrlType] = ctrlAttrs;
          return ctrlAttrs;
        }
      },
      configurable: true
    });
    Object.defineProperty(__designOptions__, ctrlType, {
      get() {
        // if (ctrlType == "dsf.textbox") {
        //   debugger;
        // }
        if (__designOptionsValue__[ctrlType]) {
          return __designOptionsValue__[ctrlType];
        } else {
          let mixins = $getMinixsAndExtends(options, true, ["props", "design"]);
          let designNode = $mergeData(design || {}, mixins["design"]);
          __designOptionsValue__[ctrlType] = designNode;
          return designNode;
        }
      },
      configurable: true
    });
    Object.defineProperty(options, "design", {
      get() {
        return getComponentDesignOptions(ctrlType);
      },
      configurable: true,
      enumerable: true
    });
  }
}

function mergeCtrlProp(ctrl, props) {
  if (props) {
    for (let k in props) {
      if (uitl.helper.isObject(props[k])) {
        ctrl[k] = uitl.helper.mix(true, {}, props[k]);
      } else if (uitl.helper.isArray(props[k])) {
        ctrl[k] = uitl.helper.mix(true, [], props[k]);
      } else {
        ctrl[k] = props[k];
      }
    }
  }
  return ctrl;
}

function getVueComponentOptions(obj) {
  if (dsf.isFunction(obj)) {
    if (!obj.cid) {
      if (obj.$lazy) {
        if (obj.resolved) {
          return obj.resolved.realOptions || obj.resolved.extendOptions;
        }
      } else {
        if (obj.resolved) {
          return obj.resolved.extendOptions;
        }
      }
    }
  } else if (dsf.isObject(obj)) {
    return obj;
  }
  return null;
}
//创建一个组件对象
function createComponent(key, attributes) {
  if (dsf.isString(key)) {
    if (!__ctrls__[key]) {
      getComponentOptions(key);
    }
    if (__ctrls__[key]) {
      let ctrl = __ctrls__[key];
      if (dsf.isFunction(ctrl) && ctrl.$lazy && ctrl.resolved) {
        ctrl.resolved;
        ctrl = __ctrls__[key];
      }
      //将组件ctrlType、ctrlName提取出来,避免被attributes中相同属性覆盖
      let retain = {
        ctrlType: __ctrls__[key].ctrlType,
        ctrlName: __ctrls__[key].ctrlName
      };
      attributes = attributes || {};
      let cloneCtrl = dsf.mix(true, {}, ctrl);
      let attrs = dsf.mix({}, mergeCtrlProp(cloneCtrl, attributes), retain);
      if (!attrs.designId) {
        attrs.designId = dsf.uuid();
      }
      return attrs;
    }
  } else {
    let com = getVueComponentOptions(key);
    if (!__ctrls__[com.ctrlType]) {
      component(com);
    }
    return createComponent(com.ctrlType, attributes);
  }
}
//获取组件选项配置
function getComponentOptions(key) {
  if (dsf.isString(key)) {
    if (key.startsWith("dsf.")) {
      if (__options__[key]) {
        let it = __options__[key];
        let options = null;
        return getVueComponentOptions(it);
      }
      return null;
    } else {
      if (Vue.options.components[key]) {
        let it = Vue.options.components[key];
        return getVueComponentOptions(it);
      }
    }
  } else {
    return getVueComponentOptions(key);
  }
  // if (__options__[key]) {
  //   let it = __options__[key];
  //   let options = null;
  //   if (dsf.isFunction(it) && it.$lazy && it.resolved) {
  //     options = it.resolved.realOptions || it.resolved.extendOptions;
  //   } else {
  //     options = it;
  //   }
  //   return options;
  // }
}

//获取组件design节点配置信息
function getComponentDesignOptions(key) {
  if (!__designOptions__[key]) {
    getComponentOptions(key);
  }
  return __designOptions__[key];
}

//补全加载布局时候组件属性
function fillComponentDefaultProps(props, callback) {
  if (props) {
    let c = dsf.createComponent(props.ctrlType);
    if (c) {
      //补丁：修复日期组件之前有$开头的属性，后续做了清理后，以前保存的表单
      for (let k in props) {
        if (k.startsWith("$")) {
          props[k.substr(1)] = props[k];
          delete props[k];
        }
      }
      let to_slots = c.slots.slice(0);
      let from_slots = props.slots.slice(0);
      let source = dsf.mix(c, props);
      _.each(to_slots, (el) => {
        let index = _.findIndex(from_slots, (el1) => {
          return el1.name == el.name;
        });
        if (index >= 0) {
          for (let k in el) {
            if (from_slots[index][k] == undefined) {
              from_slots[index][k] = el[k];
            }
          }
        } else {
          from_slots.push(el);
        }
      });
      dsf.mix(props, source, { slots: from_slots });
      callback && callback(c);
      if (props.slots) {
        _.each(props.slots, (slot) => {
          let controls = slot.controls;
          _.each(controls, (ctrlProps) => {
            fillComponentDefaultProps(ctrlProps, callback);
          });
        });
      }
    }
  }
  return props;
}

//递归组件及子组件
function recursionComponentProps(props, callback) {
  if (props) {
    callback && callback(props);
    if (props.slots) {
      _.each(props.slots, (slot) => {
        let controls = slot.controls;
        _.each(controls, (ctrlProps) => {
          recursionComponentProps(ctrlProps, callback);
        });
      });
    }
  }
}
//检查组件名是否符合要求
function checkComponentName(name) {
  if (!dsf.isString(name) || !name) {
    throw "组件缺少name属性";
  }
  if (!name.startsWith("Dsf") && !name.startsWith("DSFMobile")) {
    throw "组件" + name + "的name属性PC端组件必须以Dsf开头，移动端组件必须以DsfMobile开发头";
  }
  pascalCaseRE.lastIndex = 0;
  if (!pascalCaseRE.test(name)) {
    throw name + "组件name属性请使用PascalCase方式命名";
  }
}
//注册异步组件
function defineAsyncComponent(name, options) {
  checkComponentName(name);
  let factory = Vue.defineAsyncComponent(options);
  let code = getCtrlCodeByName(name);
  factory.ctrlName = name;
  let ctrlType = (factory.ctrlType = code);
  if (!__options__[ctrlType]) {
    __options__[ctrlType] = factory;
  }
  return factory;
}

//注册初始化不执行的组件
function defineLazyComponent(name, component) {
  checkComponentName(name);
  let factory = Vue.defineLazyComponent(component);
  let code = getCtrlCodeByName(name);
  factory.ctrlName = name;
  // factory.options = component;
  let ctrlType = (factory.ctrlType = code);
  if (!__options__[ctrlType]) {
    __options__[ctrlType] = factory;
  }
  return factory;
}

//减少window再resize时候的函数调用，特别是IE会出现严重的屏幕闪烁
let d = _.debounce($resizeComponent, 50);
// let d=$resizeComponent
function resizeDetector() {
  window.removeEventListener("resize", d);
  window.addEventListener("resize", d);
}

async function $resizeComponent(event, component) {
  let com = component;
  if (!com) {
    com = document.querySelectorAll(".ds-page");
  } else {
    com = [com];
  }
  for (let i = 0; i < com.length; i++) {
    let el = com[i];
    let component = el._isVue ? el : el.__vue__;
    await $resize(component);
  }
}

async function $resize(component) {
  if (component) {
    if (component.ctrlType && component.resize && !component.$$getComponent) {
      try {
        await component.resize();
      } catch (ex) {
        console.log(component);
        throw ex;
      }
    }
    if (component.$children) {
      for (let i = 0; i < component.$children.length; i++) {
        let children = component.$children[i];
        await $resize(children);
      }
    }
  }
}

//获取混入信息
function $getMinixsAndExtends(options, isRoot, nodes) {
  let result = {},
    instance = {};
  let arr = [];
  let extend = options.extends;
  let mixins = options.mixins || [];
  if (dsf.isDef(extend)) {
    arr = arr.push(extend);
  }
  if (mixins && mixins.length) {
    arr = arr.concat(mixins);
  }
  if (isRoot === false) {
    for (let k in nodes) {
      if (options[nodes[k]]) {
        result[nodes[k]] = dsf.mix({}, options[nodes[k]]);
      }
    }
  }

  if (arr && arr.length) {
    for (let i = arr.length - 1; i >= 0; i--) {
      // for (let i = 0; i < arr.length; i++) {
      let from = $getMinixsAndExtends(arr[i], false, nodes);
      result = $mergeData(result, from);
    }
  }
  instance = $mergeData(instance, result);
  return instance;
}

//获取组件attributes函数中的对象
function $getAttributes(options, props) {
  let attributes = {},
    mixinsAttributes = {},
    instance = {};
  for (let k in options.props) {
    let attrVal;
    if (dsf.hasOwn(options.props[k], "default")) {
      let defaultVal = undefined;
      let propDefault = options.props[k].default;
      let type = options.props[k].type;
      if (type && (type === Function || type[0] === Function)) {
        defaultVal = propDefault;
      } else {
        defaultVal = dsf.isFunction(propDefault) ? propDefault() : propDefault;
      }
      attrVal = defaultVal;
    }
    attributes[k] = attrVal;
  }
  for (let k in props) {
    let attrVal;
    if (dsf.hasOwn(props[k], "default")) {
      let defaultVal = undefined;
      let propDefault = props[k].default;
      if (props[k].type && props[k].type === Function) {
        defaultVal = propDefault;
      } else {
        defaultVal = dsf.isFunction(propDefault) ? propDefault() : propDefault;
      }
      attrVal = defaultVal;
    }
    mixinsAttributes[k] = attrVal;
  }
  $mergeData(attributes, mixinsAttributes);
  instance = $mergeData(instance, attributes);
  return instance;
}

//合并组件属性
function $mergeData(to, from) {
  if (!from) {
    return to;
  }
  var key, toVal, fromVal;
  var keys = hasSymbol ? Reflect.ownKeys(from) : Object.keys(from);

  for (var i = 0; i < keys.length; i++) {
    key = keys[i];
    toVal = to[key];
    fromVal = from[key];
    if (!dsf.hasOwn(to, key)) {
      to[key] = fromVal;
    } else if (toVal !== fromVal) {
      if (dsf.isPlainObject(toVal) && dsf.isPlainObject(fromVal)) {
        $mergeData(toVal, fromVal);
      }
    }
  }
  return to;
}

//混入attributes
function $minixAttributes(options, mixinsProps) {
  // let key = dsf.kebabCase(options.name, "-");
  let ctrlAttrs = $getAttributes(options, mixinsProps);
  ctrlAttrs.ctrlName = options.name;
  ctrlAttrs.ctrlType = options.ctrlType;
  //如果组件存在元数据
  if (ctrlAttrs.metadata) {
    // let arr = options.ctrlType.split(/\.|-/g)
    ctrlAttrs.metadata.currentControl = { text: options.ctrlCaption, value: options.ctrlType };
    ctrlAttrs.metadata.controls = [ctrlAttrs.metadata.currentControl];
  }
  return ctrlAttrs;
}

function getComponentMixins(vm) {
  let arr = [];
  let mixins = vm.$options ? vm.$options.mixins : vm.mixins;
  _.each(mixins, (it) => {
    let arr2 = getComponentMixins(it);
    _.each(arr2, (it) => {
      arr.push(it);
    });
    arr.push(it);
  });
  return arr;
}

function getCtrlCodeByName(name) {
  componentNameRE.lastIndex = 0;
  let code = componentNameRE.exec(name);
  let arr = [];
  if (code && code.length > 0) {
    for (let i = 1; i < code.length; i++) {
      if (code[i]) {
        arr.push(code[i].toLowerCase());
      }
    }
  }
  return arr.join(".");
}

function getAllComponentsOptions() {
  return __options__;
}
//检查异步组件
function checkAsyncComponent(tag) {
  //先从vue中尝试判断,如果没找到则到平台的组件注册中判断
  let component = Vue.options.components[tag];
  if (!component) {
    if (tag.startsWith('DsfMobile')) {
      tag = tag.replace('DsfMobile', 'dsf.mobile.').toLocaleLowerCase();
    }
    if (tag.startsWith('Dsf')) {
      tag = tag.replace('Dsf', 'dsf.').toLocaleLowerCase();
    }
    component = __options__[tag];
  }
  //普通组件是一个object或者是一个VueComponent的构造函数，而异步组件则是一个方法且没有cid这个属性
  if (dsf.isFunction(component) && !component.$lazy && !component.resolved && !component.cid) {
    return component;
  }
}
function requestAsyncComponents(asyncComponents) {
  if (!dsf.isArray(asyncComponents)) {
    asyncComponents = [asyncComponents];
  }
  let list = [];
  let components = [];
  _.each(asyncComponents, (it) => {
    if (dsf.isFunction(it)) {
      if (it()?.component) {
        list.push(it);
        components.push(it().component);
      }
    }
  });
  return Promise.all(components).then((res) => {
    _.each(res, (com, i) => {
      if (dsf.isFunction(__options__[com.ctrlType])) {
        __options__[com.ctrlType] = com;
      }
      let Ctor = ensureVueCtor(com, Vue);
      list[i].resolved = Ctor;
    });
  });
}

function getEsModule(module) {
  if (module.__esModule || (hasSymbol && module[Symbol.toStringTag] === "Module")) {
    module = module.default;
  }
  return module;
}
//确认组件类型
function ensureVueCtor(comp, base) {
  comp = getEsModule(comp);
  return dsf.isObject(comp) ? base.extend(comp) : comp;
}
function resizeComponent(page) {
  return new Promise((resolve, reject) => {
    $resizeComponent(null, page).then(() => {
      Vue.nextTick(() => {
        resolve();
      });
    });
  });
}

export default {
  component,
  createComponent,
  initComponents,
  checkAsyncComponent,
  requestAsyncComponents,
  fillComponentDefaultProps,
  recursionComponentProps,
  getComponentDesignOptions,
  resizeDetector,
  resizeComponent,
  getComponentOptions,
  getComponentMixins,
  getCtrlCodeByName,
  getAllComponentsOptions,
  defineAsyncComponent,
  defineLazyComponent,
  getEsModule,
  ensureVueCtor
};
